import type { DocMigration } from "../docMigration";
import { migrateModelToExtendDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_66: DocMigration = {
  maxSchemaVersion: "0.0.66",
  description:
    "Ensure that all relevant entities refactored to extend DocEntityBase are properly migrated after change was made to migration util",
  apply(json: any) {
    if (json.sheets) {
      migrateModelToExtendDocEntityBase(json, "sheets");
    }

    if (json.palettes) {
      migrateModelToExtendDocEntityBase(json, "palettes");
    }

    if (json.facades) {
      migrateModelToExtendDocEntityBase(json, "facades");
    }

    if (json.referenceGeom) {
      migrateModelToExtendDocEntityBase(json, "referenceGeom");
    }

    if (json.elevations) {
      migrateModelToExtendDocEntityBase(json, "elevations");
    }

    return json;
  },
};

export default migration_0_0_66;
